import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "wouter";
import { scrollToTop } from "@/hooks/use-scroll-to-top";
import logoImage from "@assets/image_1749670714467.png";

export default function Footer() {
  return (
    <footer className="bg-dark-slate py-16 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="md:col-span-1 lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src={logoImage} 
                alt="UnicornClub Logo" 
                className="w-12 h-12 md:w-14 md:h-14 object-contain flex-shrink-0"
              />
              <span className="text-2xl font-bold text-white">UnicornClub</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm">Connecting funded FinTech startups with elite South African IT talent.</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-cyber-purple transition-colors">
                <Mail className="text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-cyber-purple transition-colors">
                <Phone className="text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-cyber-purple transition-colors">
                <MapPin className="text-xl" />
              </a>
            </div>
          </div>
          
          <div className="md:col-span-1 lg:col-span-1">
            <h4 className="font-bold mb-4 text-white">Company</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link href="/about" onClick={scrollToTop} className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link href="/howitworks" onClick={scrollToTop} className="hover:text-white transition-colors">How It Works</Link></li>
              <li><Link href="/faq" onClick={scrollToTop} className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link href="/blog" onClick={scrollToTop} className="hover:text-white transition-colors">Blog</Link></li>
            </ul>
          </div>
          
          
          <div className="md:col-span-1 lg:col-span-1">
            <h4 className="font-bold mb-4 text-white">Contact</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center">
                <Mail className="mr-2 w-4 h-4 flex-shrink-0" />
                <span className="break-all">info@unicornclub.io</span>
              </li>
              <li className="flex items-center">
                <Phone className="mr-2 w-4 h-4 flex-shrink-0" />
                <span>+27219134061</span>
              </li>
              <li className="flex items-start">
                <MapPin className="mr-2 w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm leading-relaxed">First Floor, Willowbridge Centre, Bellville Park, Carl Cronje Dr, Cape Town, WC, South Africa 7530</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2024 UnicornClub.io. All rights reserved. | <a href="#" className="hover:text-white">Privacy Policy</a> | <a href="#" className="hover:text-white">Terms of Service</a></p>
        </div>
      </div>
    </footer>
  );
}